/*
 Created by CHT 2020/10/10 17:51
 */
import Checkbox from './Checkbox'
import { FORM_ITEM__IMAGE_CHOOSE } from '../types'


class ImageChoose extends Checkbox {
  constructor () {
    super()

    this.options = []

    this.defaultValue = null
  }

  get title () {
    return this.fieldTitle || ImageChoose._title
  }

  set title (val) {
    this.fieldTitle = val
  }
}

ImageChoose._title = '图片选项'
ImageChoose.type = FORM_ITEM__IMAGE_CHOOSE
ImageChoose.use = true
ImageChoose.icon = 'iconfont icon-checkbox'
ImageChoose.createOption = function (name, img) {
  return {
    optionName: name || '未命名',
    optionImage: img,
    chooseLimit: 0,
    defaultSelect: 0, //是否是默认选中
    alertText: '',
    id: name || '未命名'
  }
}

ImageChoose.prototype.defaultValueList = []
ImageChoose.prototype.type = ImageChoose.type

ImageChoose.prototype.valueToString = function (value) {
  value = value || this.value
  return  this.options
    .filter(opt => value.includes(opt.id))
    .map(opt=> opt.optionName)
    .join('、')
}

export default ImageChoose
